export type Currency = 'Euro' | 'Franc' | 'Krona' | 'Zloty' | 'Krone' | 'Koruna' | 'Mark'

const currencySigns: Record<Currency, string> = {
  Euro: '€',
  Franc: 'CHF',
  Krona: 'kr.',
  Zloty: 'zł',
  Krone: 'kr.',
  Koruna: 'Kč',
  Mark: 'KM',
}

export const getCurrencySign = (currency: Currency | undefined): string => {
  return currencySigns[currency || 'Euro'] ?? '€'
}

const currencyCodes: Record<Currency, string> = {
  Euro: 'EUR',
  Franc: 'CHF',
  Krona: 'SEK',
  Zloty: 'PLN',
  Krone: 'NOK',
  Koruna: 'CZK',
  Mark: 'BAM',
}

export const getCurrencyCode = (currency: Currency | undefined): string => {
  return currencyCodes[currency || 'Euro'] ?? 'EUR'
}
